import {
    useEffect,
    useState,
    useMemo,
    useRef,
    useCallback
} from 'react';
import {
    Container,
    Controls,
    Progress
} from './styled';
import {
    Card
} from './components/Card';
import { SelectList, SelectMultipleCustomerService } from '../../../../../../components';
import { useChat } from '../../../../../../contexts/chat';
import { IoRefreshCircleSharp } from 'react-icons/io5';

export function Open(props) {

    const { isVisibility } = props;

    const {
        customer,
        fullChatsOpen,
        handleFullChats,
        onFilter,
        resetChat,
        idChat
    } = useChat();

    const [dataCustomer, setDataCustomer] = useState({});
    const [displayedPeople, setDisplayedPeople] = useState(50);
    const listRef = useRef(null);
    const [optionsFilter, setOptionsFilter] = useState([]);
    const [controls, setControls] = useState(
        {
            refresh: { value: 10, label: '10s' },
            filter: { value: '', label: 'Todos Usuários' }
        }
    );
    const optionsRefresh = [
        { value: 10, label: '10s' },
        { value: 15, label: '15s' },
        { value: 20, label: '20s' }
    ];
    const [selectedCustomer, setSelectedCustomer] = useState({
        isOpen: false,
        customerServicersID: []
    });

    useEffect(() => {
        onRefresh();
    }, [])
    useEffect(() => {
        setDataCustomer(
            (typeof customer === 'string')
                ? JSON.parse(customer)
                : customer
        )
    }, [customer]);
    const onRefresh = useCallback(() => {
        handleFullChats()
    }, []);
    useEffect(() => {
        let interval;
        if (!isVisibility) return () => clearInterval(interval);
        interval = setInterval(() => {
            onRefresh();
        }, controls.refresh.value * 1000);
        return () => clearInterval(interval);
    }, [controls.refresh.value, isVisibility, onRefresh]);

    useEffect(() => {
        let uniqueNames = fullChatsOpen
            .map(obj => ({ value: obj?.usuario_id, label: obj?.nomecompleto }))
            .filter((value, index, self) => self.findIndex(
                obj => obj?.value === value?.value) === index
            )
            .sort((a, b) => a.label?.localeCompare(b.label));
        uniqueNames = [{ value: '', label: 'Todos Usuários' }, ...uniqueNames];
        const exists = uniqueNames.some(
            option => option.value === controls.filter.value
        );
        if (!exists) {
            setControls({
                ...controls,
                filter: {
                    value: '',
                    label: 'Todos Usuários'
                }
            });
        }
        setOptionsFilter(uniqueNames);
    }, [fullChatsOpen]);
    useEffect(() => {
        const element = listRef.current;
        element.addEventListener('scroll', handleScroll);
        return () => element?.removeEventListener('scroll', handleScroll);
    }, []);
    const handleScroll = () => {
        const element = listRef.current;
        if (element.scrollTop + element.clientHeight + 50 >= element.scrollHeight) {
            setDisplayedPeople(prevCount => prevCount + 50);
        }
    };
    const onFilterName = (customerService) => {
        if (!controls?.filter?.value) return true;
        return customerService?.usuario_id === controls?.filter?.value;
    };
    const visibleData = fullChatsOpen
        .filter(
            (e) => {
                return onFilter(e, 2)
            }
        )
        .filter(onFilterName)
        ?.slice(0, displayedPeople);

    const allIDS = fullChatsOpen?.map((item) => item.id);
    const onSelectedCustomer = (id) => {
        setSelectedCustomer(prev => {
            const updatedCustomerServicersID = prev.customerServicersID.includes(id)
                ? prev.customerServicersID.filter(item => item !== id)
                : [...prev.customerServicersID, id];
            return {
                ...prev,
                customerServicersID: updatedCustomerServicersID
            };
        });
    };


    const handleSelectedAll = (e) => {
        if (e) {
            setSelectedCustomer({
                isOpen: true,
                customerServicersID: allIDS
            });
            return
        }
        setSelectedCustomer({
            isOpen: true,
            customerServicersID: []
        });
    };

    const myStateElements = useMemo(() => {
        return visibleData
            .map((item, key) => (
                <Card
                    key={key}
                    data={item}
                    active={dataCustomer && dataCustomer.id === visibleData[key].id}
                    loadChats={handleFullChats}
                    onSelectedCustomer={onSelectedCustomer}
                    selectedCustomer={selectedCustomer}
                />
            ))
    }, [visibleData, dataCustomer, handleFullChats, controls.filter, selectedCustomer]);

    useEffect(() => {
        if (!isVisibility) return
        if (!fullChatsOpen) return
        const isChatOpen = fullChatsOpen?.some(item => item.client_phone === idChat)
        if (!isChatOpen) {
            resetChat();
        }
    }, [fullChatsOpen]);

    useEffect(() => {
        if (!isVisibility) return
        if (!fullChatsOpen) return
        const isChatOpen = fullChatsOpen?.some(item => item.client_phone === idChat)
        if (!isChatOpen) {
            resetChat();
        }
    }, [fullChatsOpen]);

    useEffect(() => {
        if (!isVisibility) return
        if (!fullChatsOpen) return
        const isChatOpen = fullChatsOpen?.some(item => item.client_phone === idChat)
        if (!isChatOpen) {
            resetChat();
        }
    }, [fullChatsOpen]);

    return (
        <Container ref={listRef} visibility={isVisibility ? 1 : 0}>
            <Controls>
                <div>
                    <SelectList
                        className='tiRF'
                        options={optionsRefresh}
                        value={controls.refresh}
                        onChange={(value) => setControls(
                            {
                                ...controls,
                                refresh: value
                            }
                        )}
                        defaultValue={optionsRefresh[0]}
                    />
                    <span onClick={() => onRefresh()}>
                        <IoRefreshCircleSharp className='icRf' />
                    </span>
                </div>
                <div>
                    <SelectList
                        options={optionsFilter}
                        value={controls.filter}
                        onChange={(value) => setControls({
                            ...controls,
                            filter: value
                        })}
                        placeholder={`Filtrar por Usuário`}
                        isSearchable={true}
                    />
                </div>
            </Controls>
            {myStateElements?.length !== 0 && (
                <SelectMultipleCustomerService
                    isOpen={selectedCustomer.isOpen}
                    customersSelected={selectedCustomer.customerServicersID}
                    customerServicesAll={allIDS?.length}
                    onClose={() => {
                        setSelectedCustomer({
                            isOpen: false,
                            customerServicersID: []
                        })
                    }}
                    onOpen={() => {
                        setSelectedCustomer({
                            isOpen: true,
                            customerServicersID: []
                        })
                    }}
                    onSelectAll={(e) => {
                        handleSelectedAll(e)
                    }}
                    actions={{
                        initialize: false,
                        transfer: true,
                        finish: false
                    }}
                />
            )}
            {myStateElements}
        </Container>
    );
}   